<template>
  <button
    v-if="props.showActionButton"
    :data-testid="props.dataTestId"
    class="border px-6 py-2 text-sm uppercase font-montserrat font-semibold focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none font-medium shadow-sm"
    :class="{
      'bg-teal-900 text-white hover:bg-white hover:text-teal-900 hover:border-gray-300': filled,
      'bg-white text-teal-900 hover:bg-teal-light border-teal-900': outlined,
      customClass,
    }"
    @click.prevent="clickEvent(data)"
  >
    {{ label }}
  </button>
  <div v-else class="flex justify-center">
    <CheckIcon />
  </div>
</template>
<script setup>
import { computed } from "vue";
import { CheckIcon } from "@/components/shared/icons/index.js";

const emit = defineEmits(["clicked-event"]);

const props = defineProps({
  label: {
    type: String,
    default: "APPROVE",
  },
  data: {
    type: Object,
    default: undefined,
  },
  customClass: {
    type: String,
    default: "mb-12 uppercase w-10 h-8 p-4",
  },
  outlined: {
    type: Boolean,
    default: false,
  },
  showActionButton: {
    type: Boolean,
    default: false,
  },
  dataTestId: {
    type: String,
    default: "action-button",
  },
});

const filled = computed(() => !props.outlined);

const clickEvent = (data) => {
  emit("clicked-event", data, true);
};
</script>
